import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import { IStats } from '@interfaces/stats.interface';
import { Observable } from 'rxjs';
import { ICustomer, TCustomerApi, TCustomerUpdatePayload } from './customers.interface';

@Injectable({
  providedIn: 'root',
})
export class CustomersService {
  constructor(private readonly http: HttpClient) {}

  public getCustomers(params?: HttpParams): Observable<IApiResponse<TCustomerApi[]>> {
    return this.http.get<IApiResponse<TCustomerApi[]>>('customers', { params });
  }
  public getCustomer(id: string, params?: HttpParams): Observable<ICustomer | undefined> {
    return this.http.get<TCustomerApi>(`customers/${id}`, { params });
  }

  public createCustomer(customer: Omit<ICustomer, 'id'>): Observable<ICustomer> {
    return this.http.post<ICustomer>('customers', customer);
  }

  public updateCustomer(id: string, customer: Omit<TCustomerUpdatePayload, 'id'>): Observable<ICustomer> {
    return this.http.put<ICustomer>(`customers/${id}`, customer);
  }

  public deleteCustomer(id: string): Observable<ICustomer> {
    return this.http.delete<ICustomer>(`customers/${id}`);
  }

  public getCustomersStats(): Observable<IStats[]> {
    return this.http.get<IStats[]>('customers/stats');
  }
}
